import styled from '@emotion/styled';
import { PortalTerrenoTheme } from '@portalterreno/react-ui-themes';

export type StyledBadgeProps = {
  backgroundColor?: keyof PortalTerrenoTheme['palette']['colors'];
  textColor: keyof PortalTerrenoTheme['palette']['colors'];
  iconColor: keyof PortalTerrenoTheme['palette']['colors'];
};

const StyledBadge = styled.span<StyledBadgeProps>(
  {
    'display': 'inline-flex',
    'alignItems': 'center',
    'lineHeight': '18px',
    'overflow': 'hidden',
    '& > svg': {
      marginRight: 3,
      width: 20,
      height: 20
    }
  },
  ({ theme, textColor, iconColor }) => ({
    fontSize: theme.typography.fontSize.medium,
    fontWeight: theme.typography.fontWeightLight,
    borderColor: theme.palette.colors.columbiaBlue,
    ...(textColor && {
      color: theme.palette.colors[textColor]
    }),
    ...(iconColor && {
      '& > svg': {
        color: theme.palette.colors[iconColor]
      }
    })
  })
);

export default StyledBadge;
